import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
// import { AuthGuard } from './guards/auth.guard';
// import { NoAuthGuard } from './guards/nologin.guard';

import { AuthGuard } from './shared/auth.guard';
import { RoleGuard } from './shared/role.guard';
import { NoAuthGuard } from './shared/no-auth.guard';
import { CleanLayoutComponent } from './layout/clean-layout/clean-layout.component';
import { DocumentationLayoutComponent } from './layout/documentation-layout/documentation-layout.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { CustomerSearchModule } from './pages/customer-search/customer-search.module';
import { ShopsModule } from './pages/shops/shops.module';
import { NewBranchOfficeModule } from './pages/new-branch-office/new-branch-office.module';

const routes: Routes = [
  // Redirect INIT View
  {
    path: '',
    redirectTo: 'dashboard/trade-agreements',
    // redirectTo: 'dashboard/home',
    // redirectTo: 'dashboard/usuarios',
    pathMatch: 'full'
  },
  // Custom Pages
  {
    path: 'dashboard',
    component: MainLayoutComponent,
    children: [
      {
        path: 'trade-agreements',
        loadChildren: () => import('./pages/trade-agreements/trade-agreements.module').then( m => m.TradeAgreementsModule)
      },
      // {
      //   path: 'new-trade-agreement',
      //   loadChildren: () => import('./pages/new-trade-agreement/new-trade-agreement.module').then( m => m.NewTradeAgreementModule)
      // },
      {
        path: 'new-trade-agreement',
        loadChildren: () => import('./pages/new-trade-agreement/new-trade-agreement.module').then( m => m.NewTradeAgreementModule)
      },
      {
        path: 'pre-new-trade-agreement/:id',
        loadChildren: () => import('./pages/pre-new-trade-agreement/pre-new-trade-agreement.module').then( m => m.PreNewTradeAgreementModule)
      },
      {
        path: 'pre-new-trade-agreement/:id/:tradeId',
        loadChildren: () => import('./pages/pre-new-trade-agreement/pre-new-trade-agreement.module').then( m => m.PreNewTradeAgreementModule)
      },
      {
        path: 'edit-trade-agreement',
        loadChildren: () => import('./pages/edit-trade-agreement/edit-trade-agreement.module').then( m => m.EditTradeAgreementModule)
      },
      {
        path: 'smart-search',
        loadChildren: () => import('./pages/smart-search/smart-search.module').then( m => m.SmartSearchModule)
      },
      {
        path: 'charges',
        loadChildren: () => import('./pages/charges/charges.module').then( m => m.ChargesModule)
      },
      {
        path: 'edit-charge',
        loadChildren: () => import('./pages/edit-charge/edit-charge.module').then( m => m.EditChargeModule)
      },
      {
        path: 'new-charge',
        loadChildren: () => import('./pages/new-charge-request/new-charge-request.module').then( m => m.NewChargeRequestModule)
      },
      {
        path: 'new-charge/:id',
        loadChildren: () => import('./pages/new-charge-request/new-charge-request.module').then( m => m.NewChargeRequestModule)
      },
      {
        path: 'payments',
        loadChildren: () => import('./pages/payments/payments.module').then( m => m.PaymentsModule)
      },
      {
        path: 'new-payment',
        loadChildren: () => import('./pages/new-payment/new-payment.module').then( m => m.NewPaymentModule)
      },
      {
        path: 'new-payment/:id',
        loadChildren: () => import('./pages/new-payment/new-payment.module').then( m => m.NewPaymentModule)
      },
      {
        path: 'edit-payment',
        loadChildren: () => import('./pages/edit-payment/edit-payment.module').then( m => m.EditPaymentModule)
      },
      {
        path: 'billing',
        loadChildren: () => import('./pages/billing/billing.module').then( m => m.BillingModule)
      },
      {
        path: 'new-bill',
        loadChildren: () => import('./pages/new-bill/new-bill.module').then( m => m.NewBillModule)
      },
      {
        path: 'edit-bill',
        loadChildren: () => import('./pages/edit-bill/edit-bill.module').then( m => m.EditBillModule)
      },
      {
        path: 'products',
        loadChildren: () => import('./pages/products/products.module').then( m => m.ProductsModule)
      },
      {
        path: 'new-product',
        loadChildren: () => import('./pages/new-product/new-product.module').then( m => m.NewProductModule)
      },
      {
        path: 'new-product/:id',
        loadChildren: () => import('./pages/new-product/new-product.module').then( m => m.NewProductModule)
      },
      {
        path: 'edit-product',
        loadChildren: () => import('./pages/edit-product/edit-product.module').then( m => m.EditProductModule)
      },
      {
        path: 'objectives',
        loadChildren: () => import('./pages/objectives/objectives.module').then(m => m.ObjectivesModule)
      },
      {
        path: 'report-objectives', // O la ruta que le hayas asignado
        loadChildren: () => import('./pages/report-objectives/report-objectives.module').then(m => m.ReportObjectivesPageModule)
      },
      {
        path: 'new-objective',
        loadChildren: () => import('./pages/new-objective/new-objective.module').then(m => m.NewObjectiveModule)
      },
      {
        path: 'new-objective/:id',
        loadChildren: () => import('./pages/new-objective/new-objective.module').then(m => m.NewObjectiveModule)
      },
      {
        path: 'edit-objective/:id', // 👈 Esta es la sub-dirección exacta
        loadChildren: () => import('./pages/edit-objective/edit-objective.module').then(m => m.EditObjectivePageModule)
      },
      {
        path: 'customers',
        loadChildren: () => import('./pages/customers/customers.module').then( m => m.CustomersModule)
      },
      {
        path: 'new-customer',
        loadChildren: () => import('./pages/new-customer/new-customer.module').then( m => m.NewCustomerModule)
      },
      {
        path: 'customer-search',
        loadChildren: () => import('./pages/customer-search/customer-search.module').then( m => m.CustomerSearchModule)
      },
      {
        path: 'customer-record',
        loadChildren: () => import('./pages/customer-record/customer-record.module').then( m => m.CustomerRecordModule)
      },
      {
        path: 'customer-details',
        loadChildren: () => import('./pages/customer-details/customer-details.module').then( m => m.CustomerDetailsModule)
      },
      {
        path: 'approvals',
        loadChildren: () => import('./pages/approvals/approvals.module').then( m => m.ApprovalsModule)
      },
      {
        path: 'business',
        loadChildren: () => import('./pages/shops/shops.module').then( m => m.ShopsModule)
      },
      {
        path: 'business-details/:id',
        loadChildren: () => import('./pages/shop-details/shop-details.module').then( m => m.ShopDetailsModule)
      },
      {
        path: 'new-branch-office/:id',
        loadChildren: () => import('./pages/new-branch-office/new-branch-office.module').then( m => m.NewBranchOfficeModule)
      },
      {
        path: 'new-branch-office/:id/:branchOfficeId',
        loadChildren: () => import('./pages/new-branch-office/new-branch-office.module').then( m => m.NewBranchOfficeModule)
      },
      {
        path: 'new-business',
        loadChildren: () => import('./pages/new-shop/new-shop.module').then( m => m.NewShopModule)
      },
      {
        path: 'settings-business/:id',
        loadChildren: () => import('./pages/settings-shop/settings-shop.module').then( m => m.SettingsShopModule)
      },
      {
        path: 'new-business/:id',
        loadChildren: () => import('./pages/new-shop/new-shop.module').then( m => m.NewShopModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./pages/users-new/users-new.module').then( m => m.UsersNewModule)
      },
      {
        path: 'new-user',
        loadChildren: () => import('./pages/new-user/new-user.module').then( m => m.NewUserModule)
      },
      {
        path: 'new-user/:id',
        loadChildren: () => import('./pages/new-user/new-user.module').then( m => m.NewUserModule)
      },
      {
        path: 'new-role',
        loadChildren: () => import('./pages/new-role/new-role.module').then( m => m.NewRoleModule)
      },
      {
        path: 'new-role/:id',
        loadChildren: () => import('./pages/new-role/new-role.module').then( m => m.NewRoleModule)
      },
      {
        path: 'roles',
        loadChildren: () => import('./pages/roles/roles.module').then( m => m.RolesModule)
      },
      {
        path: 'permissions',
        loadChildren: () => import('./pages/permissions/permissions.module').then( m => m.PermissionsModule)
      },
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
      },
      // {
      //   path: 'users',
      //   loadChildren: () => import('./pages/users/users.module').then( m => m.UsersPageModule)
      // },
      // {
      //   path: 'business-assets/:id',
      //   loadChildren: () => import('./pages/business-assets/business-assets.module').then( m => m.BusinessAssetsPageModule)
      // },
      // {
      //   path: 'bills',
      //   loadChildren: () => import('./pages/bills/bills.module').then( m => m.BillsPageModule)
      // },
      {
        path: 'requests/:type',
        loadChildren: () => import('./pages/requests/requests.module').then( m => m.RequestsPageModule)
      },
      {
        path: 'requests/:type/:request',
        loadChildren: () => import('./pages/requests/requests.module').then( m => m.RequestsPageModule)
      },
      {
        path: 'requests',
        redirectTo: 'requests/received'
      },
      {
        path: 'account',
        loadChildren: () => import('./pages/account/account.module').then( m => m.AccountPageModule)
      },
      {
        path: 'account-security',
        loadChildren: () => import('./pages/account-security/account-security.module').then( m => m.AccountSecurityPageModule)
      },
      // {
      //   path: 'devices',
      //   loadChildren: () => import('./pages/devices/devices.module').then( m => m.DevicesPageModule)
      // },
      // {
      //   path: 'vehicles',
      //   loadChildren: () => import('./pages/vehicles/vehicles.module').then( m => m.VehiclesPageModule)
      // },
      // {
      //   path: 'organizaciones',
      //   loadChildren: () => import('./pages/organizations/organizations.module').then( m => m.OrganizationsPageModule)
      // },
      {
        path: 'notifications',
        loadChildren: () => import('./pages/notifications/notifications.module').then( m => m.NotificationsPageModule)
      },
      {
        path: 'assets',
        loadChildren: () => import('./pages/assets-view/assets-view.module').then( m => m.AssetsViewModule)
      },
      {
        path: 'new-asset',
        loadChildren: () => import('./pages/new-asset/new-asset.module').then( m => m.NewAssetModule)
      },
      {
        path: 'new-asset/:id',
        loadChildren: () => import('./pages/new-asset/new-asset.module').then( m => m.NewAssetModule)
      },
      {
        path: 'asset-types',
        loadChildren: () => import('./pages/asset-types-view/asset-types-view.module').then( m => m.AssetTypesViewModule)
      },
      {
        path: 'new-asset-type',
        loadChildren: () => import('./pages/new-asset-type/new-asset-type.module').then( m => m.NewAssetTypeModule)
      },
      {
        path: 'new-asset-type/:id',
        loadChildren: () => import('./pages/new-asset-type/new-asset-type.module').then( m => m.NewAssetTypeModule)
      },
      {
        path: 'asset-locations',
        loadChildren: () => import('./pages/asset-locations-view/asset-locations-view.module').then( m => m.AssetLocationsViewModule)
      },
      {
        path: 'asset-dashboard',
        loadChildren: () => import('./pages/asset-dashboard/asset-dashboard.module').then( m => m.AssetDashboardModule)
      },
      {
        path: 'asset-requests',
        loadChildren: () => import('./pages/asset-requests-view/asset-requests-view.module').then( m => m.AssetRequestsViewModule)
      },
      {
        path: 'asset-pickups',
        loadChildren: () => import('./pages/asset-pickups-view/asset-pickups-view.module').then( m => m.AssetPickupsViewModule)
      },
      {
        path: 'asset-pickup',
        loadChildren: () => import('./pages/asset-pickup-view/asset-pickup-view.module').then( m => m.AssetPickupViewModule)
      },
      {
        path: 'asset-pickup/:id',
        loadChildren: () => import('./pages/asset-pickup-view/asset-pickup-view.module').then( m => m.AssetPickupViewModule)
      },
      {
        path: 'new-asset-request',
        loadChildren: () => import('./pages/new-asset-request/new-asset-request.module').then( m => m.NewAssetRequestModule)
      },
      {
        path: 'new-asset-request/:id',
        loadChildren: () => import('./pages/new-asset-request/new-asset-request.module').then( m => m.NewAssetRequestModule)
      },
      // Page Backend
      // {
      //   path: 'user/:page-form',
      //   loadChildren: () => import('./pages/form-user/form-user.module').then( m => m.FormUserPageModule)
      // },
      // {
      //   path: 'user/:page-form/:id',
      //   loadChildren: () => import('./pages/form-user/form-user.module').then( m => m.FormUserPageModule)
      // },
      // {
      //   path: 'vehicle/:page-form',
      //   loadChildren: () => import('./pages/form-vehicle/form-vehicle.module').then( m => m.FormVehiclePageModule)
      // },
      // {
      //   path: 'vehicle/:page-form/:id',
      //   loadChildren: () => import('./pages/form-vehicle/form-vehicle.module').then( m => m.FormVehiclePageModule)
      // },
      // {
      //   path: 'device/:page-form',
      //   loadChildren: () => import('./pages/form-device/form-device.module').then( m => m.FormDevicePageModule)
      // },
      // {
      //   path: 'device/:page-form/:id',
      //   loadChildren: () => import('./pages/form-device/form-device.module').then( m => m.FormDevicePageModule)
      // },
      // {
      //   path: 'location/:page-form',
      //   loadChildren: () => import('./pages/form-ubication/form-ubication.module').then( m => m.FormUbicationPageModule)
      // },
      // {
      //   path: 'location/:page-form/:id',
      //   loadChildren: () => import('./pages/form-ubication/form-ubication.module').then( m => m.FormUbicationPageModule)
      // },
      // {
      //   path: 'organization/:page-form',
      //   loadChildren: () => import('./pages/form-organization/form-organization.module').then( m => m.FormOrganizationPageModule)
      // },
      // {
      //   path: 'organization/:page-form/:id',
      //   loadChildren: () => import('./pages/form-organization/form-organization.module').then( m => m.FormOrganizationPageModule)
      // },
      // {
      //   path: 'assets/:id',
      //   loadChildren: () => import('./pages/assets/assets.module').then( m => m.AssetsPageModule)
      // },
      // {
      //   path: ':page-table',
      //   loadChildren: () => import('./pages/page-table/page-table.module').then( m => m.PageTablePageModule)
      // },
      // {
      //   path: ':model/:page-form',
      //   loadChildren: () => import('./pages/page-form/page-form.module').then( m => m.PageFormPageModule)
      // },
      // {
      //   path: ':model/:page-form/:id',
      //   loadChildren: () => import('./pages/page-form/page-form.module').then( m => m.PageFormPageModule)
      // }
    ],
    canActivate: [AuthGuard]
  },
  // PAGES WITHOUT AUTHENTICATION
  {
    path: '',
    component: CleanLayoutComponent,
    children: [
      {
        path: 'auth',
        redirectTo: 'auth/login',
      },
      {
        path: 'auth/login',
        loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
        // canActivate: [NoAuthGuard]
      },
      {
        path: 'auth/register',
        loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule),
        canActivate: [NoAuthGuard]
      },
      {
        path: 'auth/check',
        loadChildren: () => import('./pages/auth-check/auth-check.module').then( m => m.AuthCheckPageModule),
        canActivate: [NoAuthGuard]
      },
      //simple auth
      {
        path: 'auth/check/:token/:item/:permissions',
        loadChildren: () => import('./pages/auth-check/auth-check.module').then( m => m.AuthCheckPageModule),
        canActivate: [NoAuthGuard]
      },
      {
        path: 'auth/logout',
        loadChildren: () => import('./pages/logout/logout.module').then( m => m.LogoutPageModule),
        // canActivate: [AuthGuard]
      },
      {
        path: 'set-password/:code',
        loadChildren: () => import('./pages/set-password/set-password.module').then( m => m.SetPasswordModule)
      },
      // {
      //   path: 'forgot-password',
      //   loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
      // }
    ]
  },
  {
    path: 'documentation',
    component: DocumentationLayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./documentations/home/home.module').then( m => m.HomePageModule)
      },
      {
        path: 'api-users',
        loadChildren: () => import('./documentations/api-users/api-users.module').then( m => m.ApiUsersPageModule)
      },
      {
        path: 'api-vehicles',
        loadChildren: () => import('./documentations/api-vehicles/api-vehicles.module').then( m => m.ApiVehiclesPageModule)
      },
      {
        path: 'organization-creation',
        loadChildren: () => import('./documentations/organization-creation/organization-creation.module').then( m => m.OrganizationCreationPageModule)
      },
      {
        path: 'item-query',
        loadChildren: () => import('./documentations/item-query/item-query.module').then( m => m.ItemQueryPageModule)
      },
      {
        path: 'city-query',
        loadChildren: () => import('./documentations/city-query/city-query.module').then( m => m.CityQueryPageModule)
      },
      {
        path: 'area-query',
        loadChildren: () => import('./documentations/area-query/area-query.module').then( m => m.AreaQueryPageModule)
      },
      {
        path: 'branch-registration',
        loadChildren: () => import('./documentations/branch-registration/branch-registration.module').then( m => m.BranchRegistrationPageModule)
      },
      {
        path: 'device-registration',
        loadChildren: () => import('./documentations/device-registration/device-registration.module').then( m => m.DeviceRegistrationPageModule)
      },
      {
        path: ':first',
        loadChildren: () => import('./documentations/documentation-intro/documentation-intro.module').then( m => m.DocumentationIntroPageModule)
      },
      {
        path: '**',
        redirectTo: 'error/404'
      }
    ],
    // canActivate: [AuthGuard]
  },
  {
    path: '',
    component: CleanLayoutComponent,
    children: [
      {
        path: '**',
        redirectTo: 'error/404'
      },
      {
        path: 'error/:error',
        loadChildren: () => import('./pages/notfound/notfound.module').then( m => m.NotFoundPageModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
